// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:560px){.rdt-text[data-v-20d94640]{font-size:3.75rem;line-height:4.56rem}}@media only screen and (min-width:1024px){.rdt-text[data-v-20d94640]{font-size:6.25rem;line-height:7.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
